export default __webpack_public_path__ + "static/media/first.82bd4ef3.png";